import { publicFormUrl } from '../public/publicUrls';

/** URL encoded in badge / form QR codes — scanned by phone or in-app scanner */
export function badgeQrUrl(token: string) {
  return publicFormUrl(token);
}
